import { connect } from 'react-redux';
import  BankSheetUpload from './BankSheetUpload';
import { bindActionCreators } from 'redux';
import { bankSheetDetailsUpload } from 'services/redux/CarLoan/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
  uploadTheBankSheet: state.CarLoan.uploadTheBankSheet,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      bankSheetDetailsUpload,
      documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BankSheetUpload);
